import { Observable } from "rxjs";
import { FionaResponse } from "@core";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { HttpClient } from "@angular/common/http";
import { Parameter, ParameterAudit } from "@core/models";

@Injectable({
    providedIn: "root"
})
export class ParameterService {
    private readonly ENDPOINT: string = "parametros";

    constructor(
        private http: HttpClient,
    ) { }

    public getColumnDefsAgg(_cellRendererParams: any) {
        return [
            {
                field: "",
                headerName: "",
                cellRenderer: "settingsCellRendererComponent",
                cellRendererParams: _cellRendererParams,
            },
            {
                field: "name",
                headerName: "Nombre",
            },
            {
                field: "description",
                headerName: "Descripción",
            },
            {
                field: "value",
                headerName: "Valor",
            },
            {
                field: "expresion",
                headerName: "Expresión",
            },
            {
                sort: "desc",
                field: "date",
                headerName: "Fecha Modificación",
            },
            {
                field: "user",
                headerName: "Usuario",
            },
        ]
    }

    public all(): Observable<FionaResponse<Array<ParameterAudit>>> {
        return this.http.get<FionaResponse<Array<ParameterAudit>>>(`${environment.urlApiFiona}${this.ENDPOINT}`);
    }

    public add(request: Parameter): Observable<FionaResponse<Array<string>>> {
        return this.http.post<FionaResponse<Array<string>>>(`${environment.urlApiFiona}${this.ENDPOINT}`, request);
    }

    public update(request: Parameter): Observable<FionaResponse<Array<string>>> {
        return this.http.put<FionaResponse<Array<string>>>(`${environment.urlApiFiona}${this.ENDPOINT}/${request.id}`, request);
    }

    public delete(id: number): Observable<FionaResponse<Array<string>>> {
        return this.http.delete<FionaResponse<Array<string>>>(`${environment.urlApiFiona}${this.ENDPOINT}`);
    }
}